import React, { useEffect, useState } from 'react';
import { loadAllNFTs } from '../../../assets/Data/NFT';
import { MarketData } from './MarketData';

function CategoriesMarket() {
  const [checkLoader, setCheckLoader] = useState(false);
  const [filter, setFilter] = useState("latest");
  const [activeTab, setActiveTab] = useState("all");

  console.log("setActiveTab", activeTab);

  const renderCategoryContent = () => {
    switch (activeTab) {
      case "games":
        return <MarketData filter={activeTab} checkLoader={checkLoader} setCheckLoader={setCheckLoader} />;
      case "Art":
        return <MarketData filter={activeTab} />;
      case "tradingCards":
        return <MarketData filter={activeTab} />;
      case "Graphics":
        return <MarketData filter={activeTab} />;
      case "domainNames":
        return <MarketData filter={activeTab} />;
      case "Others":
        return <MarketData filter={activeTab} />;
      case "Video":
        return <MarketData filter={activeTab} />;
      default:
        return <MarketData filter={filter} checkLoader={checkLoader} setCheckLoader={setCheckLoader} />;
    }
  };  // console.log("Data", userNFTS, hasMoreUserNFTS);
  return (
    <div className="w-100">
      <div className="menu_categories bg_white w-100 d-flex">
        <button
          className={`btn btn-white btn-sm m-3 ${activeTab === "all" ? "btn-dark text-white" : ""}`}
          onClick={() => setActiveTab("all")}
        >
          All
        </button>

        <button
          className={`btn btn-white btn-sm m-3 ${activeTab === "Art" ? "btn-dark text-white" : ""}`}
          onClick={() => setActiveTab("Art")}
        >
          <i className="ri-brush-line" /> Art
        </button>
        <button
          className={`btn btn-white btn-sm m-3 ${activeTab === "Graphics" ? "btn-dark text-white" : ""}`}
          onClick={() => setActiveTab("Graphics")}
        >
          <i className="ri-music-line" /> Graphics
        </button>
        <button
          className={`btn btn-white btn-sm m-3 ${activeTab === "Others" ? "btn-dark text-white" : ""}`}
          onClick={() => setActiveTab("Others")}
        >
          <i className="ri-emotion-laugh-line" /> Others
        </button>
        <button
          className={`btn btn-white btn-sm m-3 ${activeTab === "Video" ? "btn-dark text-white" : ""}`}
          onClick={() => setActiveTab("Video")}
        >
          <i className="ri-layout-4-line" /> Video
        </button>
        <button
          className={`btn btn-white btn-sm m-3 ${activeTab === "games" ? "btn-dark text-white" : ""}`}
          onClick={() => setActiveTab("games")}
        >
          <i className="ri-gamepad-line" /> Games
        </button>
        <button
          className={`btn btn-white btn-sm m-3 ${activeTab === "tradingCards" ? "btn-dark text-white" : ""}`}
          onClick={() => setActiveTab("tradingCards")}
        >
          <i className="ri-stock-line" /> Trading Cards
        </button>

        <button
          className={`btn btn-white btn-sm m-3 ${activeTab === "domainNames" ? "btn-dark text-white" : ""}`}
          onClick={() => setActiveTab("domainNames")}
        >
          <i className="ri-global-line" /> Domain Names
        </button>

      </div>

      <div className="tab-content mt-4 container">
        {renderCategoryContent()}
      </div>
    </div>
  );
}

export default CategoriesMarket;
